// src/shared.ts
var defaultEndpoint = "/api/trpc";

export {
  defaultEndpoint
};
